<template>
  <svg
    style="width:100%; height:100%"
    :data-key="number"
    viewBox="0 -200 1000 300"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect :data-key="number" x="0" y="0" widt="200" height="200" fill="white" />
    <text
      :data-key="number"
      fill="#fff"
      font-size="180"
      x="50%"
      y="-30%"
      text-anchor="middle"
      class="area-title"
    >
      A{{ number + 1 }}
    </text>
    <text
      :data-key="number"
      fill="#fff"
      font-size="110"
      y="10%"
      class="area-title"
            x="50%"

            text-anchor="middle"
      v-html="areaName"
    ></text>
    <!-- <text :data-key="number" fill="#fff" font-size="110" x="50%" y="30%" text-anchor='start' class="area-title">{{value.name}}</text> -->
  </svg>
</template>
<script>
export default {
  name: 'draggableArea',
  props: ['value', 'number'],
  computed: {
    areaName: function() {
      var words = this.chunkSubstr(this.value.name, 17)
      var tspans = ''
      var y = 0
      words.forEach(chunk => {
        tspans += `<tspan data-key="${this.number}" x="50%" dy=${y}>${chunk}</tspan>`
        y = 100
      })
      return tspans
    }
  },
  methods: {
    chunkSubstr(str, size) {
      const numChunks = Math.ceil(str.length / size)
      const chunks = new Array(numChunks)

      for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
        chunks[i] = str.substr(o, size)
      }

      return chunks
    }
  }
}
</script>
<style scoped>
.area-container {
  height: 100%;
}

.area-title {
  font-family: Roboto, "Noto Sans", Noto, sans-serif;
  font-style: normal;
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  /*
    Introduced in IE 10.
    See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
  */
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// DraggableArea.vue?e33abe48